export const productFinder = {
  applicationLabel: Drupal.t('Applications'),
  buttonSelectText: Drupal.t('Select'),
  products: Drupal.t('Products'),
  product: Drupal.t('Product'),
  resetFiltersLabel: Drupal.t('Reset filters'),
  showResults: Drupal.t('Show results'),
  shareModal: {
    copyAndShareLabel: Drupal.t('Copy & Share results'),
    copyAndShareModalText: Drupal.t(
      'Copy, save, or share this quick link to return to your Product Finder results at any time.',
    ),
    copyAndShareModalTitle: Drupal.t('Product Finder results'),
    copyFeedback: Drupal.t('Copied to clipboard'),
    emailShareSubject: Drupal.t('Your COMPO EXPERT Product Finder results'),
    quickLink: Drupal.t('Quick link'),
    whatsappShareText: Drupal.t(
      'Have a look at the COMPO EXPERT Product Finder results:',
    ),
  },
  subTitle: Drupal.t('products found'),
  targetAreasLabel: Drupal.t('Target Areas'),
};

export const productFinderFilters = {
  organicFarming: Drupal.t('Organic farming'),
  productType: Drupal.t('Product type'),
  sustainableApplication: {
    label: Drupal.t('Sustainable application'),
    greenhouseGasEfficiency: Drupal.t('Greenhouse Gas Reduction'),
    waterEfficiency: Drupal.t('Water Use Efficiency'),
    nutrientUseEfficiency: Drupal.t('Nutrient Use Efficiency'),
  },
  sustainableApplicationExplanation: {
    greenhouseGasEfficiency: {
      headline: Drupal.t('Reduced Greenhouse Gas Emissions'),
      text: Drupal.t(
        'This product reduces greenhouse gas emissions during application. Nitrogen is stabilized in plant-available form, which strongly reduces nitrous oxide emissions.',
      ),
    },
    waterEfficiency: {
      headline: Drupal.t('Enhanced Water Use Efficiency'),
      text: Drupal.t(
        'This product saves water through the precise and simultaneous application of fertilizer and water during fertigation.',
      ),
    },
    nutrientUseEfficiency: {
      headline: Drupal.t('Enhanced Nutrient Use Efficiency'),
      text: Drupal.t(
        'This product ensures that nutrients are provided exactly as required, when required. Through our slow-release, controlled release and N-stabilization technologies, nutrients are available for the plants for an extended period after application or at reduced losses into groundwater or the atmosphere.',
      ),
    },
  },
  sustainableProduction: {
    label: Drupal.t('Sustainable production'),
    co2Reduction: Drupal.t('Low-carbon raw materials'),
    modal: {
      title: Drupal.t('Low-Carbon Footprint'),
      content: [
        Drupal.t(
          'Since 2024, <span class="branding">COMPO EXPERT</span> has been using low-carbon raw materials to reduce the carbon footprint of specialty fertilizers.',
        ),
        Drupal.t(
          'The here reported reduction is achieved using low-carbon ammonia and/or potassium sulfate, which have a lower carbon footprint compared to the respective market average (-60% for ammonia and -90% for potassium sulfate). This reduction is certified by our suppliers and has been validated by an independent certification body.',
        ),
        Drupal.t(
          'Benchmarks are the average European industry emissions data from the ecoinvent 3.11 database.',
        ),
      ],
      learnMore: Drupal.t('For further information go to Sustainability page'),
    },
  },
};
